import React from 'react';
import './Loading.css';

export const Skeleton = () => (
  <div className="skeleton-grid">
    {Array.from({ length: 6 }).map((_, i) => (
      <div key={i} className="skeleton-card">
        <div className="skeleton-img shimmer" />
        <div className="skeleton-text shimmer" />
        <div className="skeleton-text skeleton-text--short shimmer" />
      </div>
    ))}
  </div>
);

export const Spinner = ({ text }) => (
  <div className="spinner-wrap">
    <div className="spinner" />
    {text && <p className="spinner-text">{text}</p>}
  </div>
);

export const EmptyState = ({ message }) => (
  <div className="empty-state">
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <rect x="6" y="10" width="36" height="28" rx="4" stroke="var(--border)" strokeWidth="2"/>
      <path d="M6 20L18 28L26 22L42 32" stroke="var(--border)" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="16" cy="18" r="3" stroke="var(--border)" strokeWidth="2"/>
    </svg>
    <p>{message || 'No products found'}</p>
  </div>
);
